import { render, staticRenderFns } from "./ClosestPopulationsTopHeader.vue?vue&type=template&id=5aab303e&scoped=true"
import script from "./ClosestPopulationsTopHeader.vue?vue&type=script&lang=js"
export * from "./ClosestPopulationsTopHeader.vue?vue&type=script&lang=js"
import style0 from "./ClosestPopulationsTopHeader.vue?vue&type=style&index=0&id=5aab303e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab303e",
  null
  
)

export default component.exports